import { connectionResourceDriver } from "./connectionResource";
import { connectorResourceDriver } from "./connectorResource";
import { contactEntityResourceDriver } from "./contactEntityResource";
import { deliveryResourceDriver } from "./deliveryResource";
import { deltaMappingResourceDriver, mappingResourceDriver } from "./mappingResource";
import { routeResourceDriver } from "./routeResource";
import { tenancySettingResourceDriver } from "./tenancySettingResource";
import type { ResourceDefinitionMap, ResourceDriver, ResourceKind } from "./types";

/** One driver per resource kind. Adding a resource kind means adding one entry here. */
const drivers: { [Kind in ResourceKind]: ResourceDriver<ResourceDefinitionMap[Kind], Kind> } = {
  connection: connectionResourceDriver,
  connector: connectorResourceDriver,
  mapping: mappingResourceDriver,
  deltaMapping: deltaMappingResourceDriver,
  route: routeResourceDriver,
  delivery: deliveryResourceDriver,
  tenancySetting: tenancySettingResourceDriver,
  contactEntity: contactEntityResourceDriver,
};

export const getResourceDriver = <Kind extends ResourceKind>(
  definition: { kind: Kind },
): ResourceDriver<ResourceDefinitionMap[Kind], Kind> =>
  drivers[definition.kind];

export const getResourceDrivers = () => Object.values(drivers);
